const Role = () =>
  import(
    /* webpackChunkName: "security-role" */ '@/pages/security/role/index.vue'
  )
const Detail = () =>
  import(
    /* webpackChunkName: "security-role" */ '@/pages/security/role/detail.vue'
  )
const CreateRole = () =>
  import(
    /* webpackChunkName: "security-role" */ '@/pages/security/role/create.vue'
  )
const EditRole = () =>
  import(
    /* webpackChunkName: "security-role" */ '@/pages/security/role/edit.vue'
  )

export default {
  path: 'role',
  meta: {
    label: 'role',
    auth: 'role'
  },
  component: {
    name: 'Role',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SecurityRoleReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Role
    },
    {
      name: 'SecurityRoleDetail',
      path: 'detail/:id',
      meta: {
        label: 'detail',
        auth: 'detail'
      },
      component: Detail,
      props: true
    },
    {
      name: 'SecurityCreateRole',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateRole
    },
    {
      name: 'SecurityEditRole',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditRole,
      props: true
    }
  ]
}
